module.exports = __webpack_public_path__ + "img/sendai.816d0308.jpg";